import { render, staticRenderFns } from "./DealCard.vue?vue&type=template&id=7a077490&scoped=true&"
import script from "./DealCard.vue?vue&type=script&lang=ts&"
export * from "./DealCard.vue?vue&type=script&lang=ts&"
import style0 from "./DealCard.vue?vue&type=style&index=0&id=7a077490&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a077490",
  null
  
)

export default component.exports